const React = require('react');

const Item = require('../common/Item.jsx');
const TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

function AcquisitionDate(props) {
    if (!Utilities.Config.checkVisibility(props, 'AcquisitionDate')) {
        return null;
    }
    const config = props.config || {};
    let blockProps = {}
    if (config.Config && config.Config.Block) {
        blockProps = config.Config.Block;
    }
    const itemData = props.itemData || {};
    let content;
    if (!Utilities.isNullOrWhitespace(itemData.AcquiredAt)) {
        content = `${blockProps.textLabel}${itemData.AcquiredAt}`;
    }
    return <Item.Meta {...props} style={{ whiteSpace: 'pre-wrap' }} value={content} />;
}
const TypeConfigAcquisitionDate = {
    panel: {
        block: function () { return Item.StringMeta.TypeConfig.panel.blockWithLabel({ value: 'Acquisition Date: ' }); },
        style: Item.StringMeta.TypeConfig.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Acquisition Date',
                        name: 'AcquisitionDate',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Artist(props) {
    return <Item.StringMeta.Component {...props} name="Artist" propName="ArtistName" />;
}

function ConsignmentCost(props) {
    if (!Utilities.Config.checkVisibility(props, 'ConsignmentCost')) {
        return null;
    }
    const config = props.config || {};
    let formatProps = {}
    if (config.Config && config.Config.Format) {
        formatProps = config.Config.Format;
    }
    const componentData = props.componentData || {};
    let currencyFormat;
    if (componentData.index == 0) {
        currencyFormat = formatProps.currencyFormatFirst;
    } else {
        currencyFormat = formatProps.currencyFormat;
    }
    const itemData = props.itemData || {};
    let localization;
    if (props.data && props.data.Gallery) {
        localization = props.data.Gallery.Localization;
    }
    const value = Utilities.Format.Currency.getDisplayString(itemData.Consignment, currencyFormat, localization);
    return <Item.Meta {...props} style={{ whiteSpace: 'pre-wrap' }} value={value} />;
}
const TypeConfigConsignmentCost = {
    panel: {
        block: function () { return Item.StringMeta.TypeConfig.panel.block(); },
        format: function () { return TypeConfig.panel.currency({ customFirstLineFormat: true }); },
        style: Item.StringMeta.TypeConfig.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Consignment Cost',
                        name: 'ConsignmentCost',
                        relatedProperties: ['ConsignmentTotal'],
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

class CustomMeta extends React.Component {
    constructor(props) {
        super(props);

        this.handleTypeValue = this.handleTypeValue.bind(this);
    }

    handleTypeValue(id, itemData) {
        switch (id) {
            case 'AcquisitionDate':
                return { value: itemData.AcquiredAt };
            case 'Artist':
                return { value: itemData.ArtistName };
            case 'ConsignmentCost':
                if (!Utilities.isNullOrWhitespace(itemData.Consignment)) {
                    let metaProps = {};
                    if (this.props.config && this.props.config.Config && this.props.config.Config.Meta) {
                        metaProps = this.props.config.Config.Meta;
                    }
                    let currencyFormat = metaProps.currencyFormatConsignmentCost;
                    if (this.props.customFirstLineFormat == true) {
                        const componentData = this.props.componentData || {};
                        if (componentData.index == 0) {
                            currencyFormat = metaProps.currencyFormatConsignmentCostFirst;
                        }
                    }
                    const data = this.props.data || {};
                    let localization = {};
                    if (data.Gallery && data.Gallery.Localization) {
                        localization = data.Gallery.Localization;
                    }
                    return { value: Utilities.Format.Currency.getDisplayString(itemData.Consignment, currencyFormat, localization) };
                }
                break;
            case 'Price':
                if (!Utilities.isNullOrWhitespace(itemData.Retail)) {
                    let metaProps = {};
                    if (this.props.config && this.props.config.Config && this.props.config.Config.Meta) {
                        metaProps = this.props.config.Config.Meta;
                    }
                    let currencyFormat = metaProps.currencyFormatPrice;
                    if (this.props.customFirstLineFormat == true) {
                        const componentData = this.props.componentData || {};
                        if (componentData.index == 0) {
                            currencyFormat = metaProps.currencyFormatPriceFirst;
                        }
                    }
                    const data = this.props.data || {};
                    let localization = {};
                    if (data.Gallery && data.Gallery.Localization) {
                        localization = data.Gallery.Localization;
                    }
                    return { value: Utilities.Format.Currency.getDisplayString(itemData.Retail, currencyFormat, localization) };
                }
                break;
            default:
                return null;
        }
    }

    render() {
        return <Item.CustomMeta.Component customFirstLineFormat={true} onTypeValue={this.handleTypeValue} {...this.props} />;
    }
}
const TypeConfigCustomMeta = {
    panel: {
        includes: function () {
            return {
                draggable: true,
                expanded: true,
                label: 'Include / Order',
                options: [
                    {
                        display: 'Artist',
                        draggable: true,
                        fullWidth: true,
                        name: 'Artist',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        display: 'Title',
                        draggable: true,
                        fullWidth: true,
                        name: 'Title',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Edition') >= 0; },
                        display: 'Edition Info',
                        draggable: true,
                        fullWidth: true,
                        name: 'Edition',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Date') >= 0; },
                        display: 'Date',
                        draggable: true,
                        fullWidth: true,
                        name: 'Date',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Medium') >= 0; },
                        display: 'Medium',
                        draggable: true,
                        fullWidth: true,
                        name: 'Medium',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Dimensions') >= 0; },
                        display: 'Dimensions',
                        draggable: true,
                        fullWidth: true,
                        name: 'Dimensions',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Number') >= 0; },
                        display: 'Inventory Number',
                        draggable: true,
                        fullWidth: true,
                        name: 'Number',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('SKU') >= 0; },
                        display: 'SKU',
                        draggable: true,
                        fullWidth: true,
                        name: 'SKU',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Location') >= 0; },
                        display: 'Location',
                        draggable: true,
                        fullWidth: true,
                        name: 'Location',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('AcquisitionDate') >= 0; },
                        display: 'Acquisition Date',
                        draggable: true,
                        fullWidth: true,
                        name: 'AcquisitionDate',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Price') >= 0; },
                        display: 'Price',
                        draggable: true,
                        fullWidth: true,
                        name: 'Price',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('ConsignmentCost') >= 0; },
                        display: 'Consignment Cost',
                        draggable: true,
                        fullWidth: true,
                        name: 'ConsignmentCost',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        name: '_sort',
                        value: ['Artist', 'Title', 'Edition', 'Date', 'Medium', 'Dimensions', 'Number', 'SKU', 'Location', 'AcquisitionDate', 'Price', 'ConsignmentCost'],
                        visible: function () { return false; }
                    },
                    {
                        name: '_export',
                        value: ['Artist', 'Title', 'Edition', 'Date', 'Medium', 'Dimensions', 'Number', 'SKU', 'Location', 'AcquisitionDate', 'Price', 'ConsignmentCost'],
                        visible: function () { return false; }
                    }
                ]
            };
        },
        meta: function () {
            return {
                expanded: false,
                label: 'Item Detail Configuration',
                options: [
                    { display: 'Acquisition Date Display Properties', id: 'acquisitionDateProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'AcquisitionDate', value: '[AcquisitionDate]' }),
                    { display: 'Artist Display Properties', id: 'artistProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Artist', value: '[Artist]' }, {}),
                    { display: 'Consignment Cost Display Properties', id: 'consignmentCostProps', type: 'header' },
                    TypeConfig.options.currency({ display: 'First Item Currency Format', name: 'ConsignmentCostFirst', visible: function (config) { return config.Includes && config.Includes.ConsignmentCost; } }),
                    ...Item.CustomMeta.TypeConfig.options.meta({ includeHelpText: false, name: 'ConsignmentCost', type: 'currency' }),
                    { display: 'Date Display Properties', id: 'dateProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Date', value: '[Date]' }, {}),
                    { display: 'Dimensions Display Properties', id: 'dimensionsProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Dimensions', value: '[Dimensions]' }),
                    { display: 'Edition Info Display Properties', id: 'editionProps', type: 'header' },
                    {
                        display: 'Limited Edition Display Format',
                        fullWidth: true,
                        helpText: () => 'Keywords: [EditionNumber], [EditionCount]',
                        name: 'formatEditionLimited',
                        type: 'format',
                        value: 'Edition [EditionNumber]/[EditionCount]',
                        visible: function (config) {
                            return config.Includes && config.Includes.Edition;
                        }
                    },
                    {
                        display: 'Unlimited Edition Display Format',
                        fullWidth: true,
                        helpText: () => 'Keywords: [EditionNumber]',
                        name: 'formatEditionUnlimited',
                        type: 'format',
                        value: 'Edition [EditionNumber]',
                        visible: function (config) {
                            return config.Includes && config.Includes.Edition;
                        }
                    },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Edition', type: 'edition' }),
                    { display: 'Inventory Number Display Properties', id: 'numberProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ keywords: '[Number]', name: 'Number', value: 'Inventory #: [Number]' }),
                    { display: 'Location Display Properties', id: 'locationProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Location', value: '[Location]' }, {}),
                    { display: 'Medium Display Properties', id: 'mediumProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Medium', value: '[Medium]' }, {}),
                    { display: 'Price Display Properties', id: 'priceProps', type: 'header' },
                    TypeConfig.options.currency({ display: 'First Item Currency Format', name: 'PriceFirst', visible: function (config) { return config.Includes && config.Includes.Price; } }),
                    ...Item.CustomMeta.TypeConfig.options.meta({ includeHelpText: false, name: 'Price', type: 'currency' }),
                    { display: 'SKU Display Properties', id: 'skuProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ keywords: '[SKU]', name: 'SKU', value: 'SKU: [SKU]' }),
                    { display: 'Title Display Properties', id: 'titleProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Title', value: '[Title]' }, {})
                ]
            };
        },
        style: Item.CustomMeta.TypeConfig.panel.style
    }
};

function Price(props) {
    return <Item.Price.Component customFirstLineFormat={true} propName="Retail" {...props} />;
}
const TypeConfigPrice = {
    panel: {
        block: Item.Price.TypeConfig.panel.block,
        format: function () { return TypeConfig.panel.currency({ customFirstLineFormat: true }); },
        style: Item.Price.TypeConfig.panel.style,
        visibility: function () { return Item.Price.TypeConfig.panel.visibility({ relatedProperties: ['RetailTotal'] }); }
    }
};

module.exports = {
    ...Item,
    AcquisitionDate: {
        Component: AcquisitionDate,
        TypeConfig: TypeConfigAcquisitionDate
    },
    Artist: {
        Component: Artist,
        TypeConfig: Item.Artist.TypeConfig
    },
    ConsignmentCost: {
        Component: ConsignmentCost,
        TypeConfig: TypeConfigConsignmentCost
    },
    CustomMeta: {
        Component: CustomMeta,
        TypeConfig: TypeConfigCustomMeta
    },
    Price: {
        Component: Price,
        TypeConfig: TypeConfigPrice
    }
};